// components/mdx/VideoBlock.jsx
"use client";

function getVideoType(src = "") {
    if (src.includes("youtube.com") || src.includes("youtu.be"))
        return "youtube";
    if (src.includes("vimeo.com")) return "vimeo";
    if (src.endsWith(".mp4") || src.endsWith(".webm")) return "file";
    return "unknown";
}

export default function VideoBlock({ src, title = "Video", ...props }) {
    const type = getVideoType(src);

    if (!src)
        return (
            <div className="bg-red-100 text-red-700 rounded p-3 my-4">
                Video source missing.
            </div>
        );

    if (type === "youtube")
        return (
            <div className="aspect-video my-4 rounded overflow-hidden">
                <iframe
                    referrerPolicy="strict-origin-when-cross-origin"
                    src={
                        src.startsWith("http")
                            ? src.replace("watch?v=", "embed/")
                            : `https://www.youtube.com/embed/${src}`
                    }
                    frameBorder="0"
                    allowFullScreen
                    title={title}
                    className="w-full h-full"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    loading="lazy"
                    {...props}
                />
            </div>
        );

    if (type === "vimeo")
        return (
            <div className="aspect-video my-4 rounded overflow-hidden">
                <iframe
                    referrerPolicy="strict-origin-when-cross-origin"
                    src={
                        src.startsWith("http")
                            ? src.replace(
                                  "vimeo.com/",
                                  "player.vimeo.com/video/"
                              )
                            : `https://player.vimeo.com/video/${src}`
                    }
                    frameBorder="0"
                    allowFullScreen
                    title={title}
                    className="w-full h-full"
                    allow="autoplay; fullscreen"
                    loading="lazy"
                    {...props}
                />
            </div>
        );

    if (type === "file")
        return (
            <div className="aspect-video my-4 rounded overflow-hidden bg-black flex items-center justify-center">
                <video
                    controls
                    title={title}
                    className="w-full h-full"
                    {...props}
                >
                    <source src={src} />
                    Your browser does not support the video tag.
                </video>
            </div>
        );

    // Unknown type fallback
    return (
        <div className="bg-yellow-100 text-yellow-800 rounded p-3 my-4 flex items-center gap-2">
            <VideoIcon className="h-4 w-4" />{" "}
            <span>Cannot embed video. Check URL.</span>
        </div>
    );
}

function VideoIcon({ className = "" }) {
    return (
        <svg
            aria-hidden="true"
            viewBox="0 0 24 24"
            className={className}
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <rect x="3" y="6" width="13" height="12" rx="2" />
            <path d="m16 10 5-3v10l-5-3" />
        </svg>
    );
}
